import React, { useEffect } from "react";
import FaqSection from "../components/Faq/FaqSection";
import { Banner } from "../components/common/Banner";
import { useAppDispatch, useAppSelector } from "../Hooks";
import { getFaqData } from "../features/Faq";
import { Loader } from "../components/common/Loader";


const Contact: React.FC<{ banner_title: string }> = ({ banner_title }) => {
    const dispatch = useAppDispatch();
    const { faq_data, faqLoader, status } = useAppSelector(state => state.faq);

    useEffect(() => {
        dispatch(getFaqData({ page: 1, limit: 10 }));
    }, [status, dispatch]);

    if (faqLoader) {
        return <Loader />;
    }
    return (
        <>
            <Banner banner_title={banner_title} />
            <FaqSection faq_data={faq_data} />
        </>
    )
}
export default Contact;